import API from "../../../Network/API";
import { isLoading, isLoaded, appDetails } from "../action";
import Alert from '../../../Alert';


export async function getDetails(dispatch) {
    dispatch(isLoading());
    try {
      var response = await API.post("faqs.php",{
        action: 'getDetails',
      }, {}, false);
      if(response.status === 'True'){
        dispatch(appDetails(response.data));
      }else{
        dispatch(appDetails([]));
      }
    } catch (error) {
        //console.log(error)
      Alert(error.message)
    }
    dispatch(isLoaded());
  }